import { Component, OnInit } from '@angular/core';

import { SpinnerService } from '../../../services/spinner.service';
import { StmtService } from '../../../services/stmt.service';

@Component({
    selector: 'app-statement-list',
    templateUrl: './statement-list.component.html',
    styleUrls: ['./statement-list.component.css']
})
export class StatementListComponent implements OnInit {
    newStmt: any = {
        month: new Date(new Date().setDate(1)).toISOString().slice(0, 10)
    }
    stmts: any[] = [];

    constructor(private spinner: SpinnerService,
        private stmtService: StmtService) { }

    ngOnInit() {
        this.getStatements();
    }

    getStatements() {
        this.spinner.startLoad('statement-list-getStatements');
        this.stmtService.getStatements().subscribe(
            (stmts) => this.stmts = stmts,
            (err) => console.error(err),
            () => this.spinner.finishLoad('statement-list-getStatements')
        );
    }

    createStatement() {
        this.spinner.startLoad('statement-list-createStatement');
        this.stmtService.createStatement(this.newStmt).subscribe(
            (stmtId) => this.getStatements(),
            (err) => console.error(err),
            () => this.spinner.finishLoad('statement-list-createStatement')
        );
    }
}
